export class HSPPoolSuggestModel implements IHSPPoolSuggestModel {
  id?: string | undefined;
  companyId?: string | undefined;
  companyName?: string | undefined;
  title?: string | undefined;
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;

  constructor(data?: IHSPPoolSuggestModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.id = Data["id"];
      this.companyId = Data["companyId"];
      this.companyName = Data["companyName"];
      this.title = Data["title"];
      this.seasonNumber = Data["seasonNumber"];
      this.seasonYear = Data["seasonYear"];
    }
  }

  static fromJS(data: any): HSPPoolSuggestModel {
    data = typeof data === 'object' ? data : {};
    let result = new HSPPoolSuggestModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["companyId"] = this.companyId;
    data["companyName"] = this.companyName;
    data["title"] = this.title;
    data["seasonNumber"] = this.seasonNumber;
    data["seasonYear"] = this.seasonYear;
    return data;
  }
}

export interface IHSPPoolSuggestModel {
  id?: string | undefined;
  companyId?: string | undefined;
  companyName?: string | undefined;
  title?: string | undefined;
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
}
